<template>
  <div>
    <p :class="pClass">
      <label>{{ labelTitle }}</label>
      <label :for="`input-${_uid}`" :class="labelClass">
        <span>
          <img v-if="image" :src="image.imageLink" alt="addImg" />
        </span>
      </label>

      <span v-if="image" :class="spanClass">
        {{ image.width }} x {{ image.height }} px<br />
        {{ Math.round(image.size / 1000) }} kB<br />
        <translate>Poměr</translate>: {{ +(image.width / image.height).toFixed(1) }}<br />
      </span>

    </p>
  </div>
</template>

<script>
export default {
  name: 'app-image',
  props: {
    width: {
      type: String,
      default: '117px'
    },
    height: {
      type: String,
      default: '161px'
    },
    title: {
      type: String,
      default: 'Obrázek'
    },
    image: {
      type: Object,
      default: null
    },
    imageLink: {
      type: String,
      default: ''
    },
    pClass: {
      type: String,
      default: ''
    },
    labelClass: {
      type: String,
      default: ''
    },
    spanClass: {
      type: String,
      default: ''
    },
    labelTitle: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
    }
  }
}
</script>
